import React, { useEffect } from 'react';

export function ChunkErrorHandler() {
  useEffect(() => {
    const handleChunkError = (event: ErrorEvent) => {
      const error = event.error;
      
      console.log('[ChunkErrorHandler] Error event:', error);
      
      // Check if it's a chunk loading error or React context error
      if (error && (
        error.message?.includes('Loading chunk') ||
        error.message?.includes('ChunkLoadError') ||
        error.message?.includes('Loading CSS chunk') ||
        error.message?.includes('Loading module') ||
        error.message?.includes('Importing a module script failed')
      )) {
        console.log('[ChunkErrorHandler] Chunk/Context loading error detected, reloading page...');
        
        // Show a brief loading message with premium design
        const loadingDiv = document.createElement('div');
        loadingDiv.innerHTML = `
          <div style="
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.95);
            backdrop-filter: blur(8px);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99999;
            font-family: 'Inter', system-ui, sans-serif;
          ">
            <div style="
              background: rgba(255, 255, 255, 0.05);
              padding: 2.5rem 3rem;
              border-radius: 1.5rem;
              border: 1px solid rgba(255, 255, 255, 0.1);
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
              text-align: center;
              max-width: 90%;
              width: 400px;
            ">
              <div style="
                width: 48px;
                height: 48px;
                border: 3px solid rgba(255, 255, 255, 0.1);
                border-top-color: #0EA5E9;
                border-radius: 50%;
                margin: 0 auto 1.5rem auto;
                animation: spin 1s linear infinite;
              "></div>
              <h2 style="font-size: 1.25rem; font-weight: 600; margin: 0 0 0.5rem 0; letter-spacing: -0.025em;">Atualizando Sistema</h2>
              <p style="font-size: 0.875rem; color: #94A3B8; margin: 0; line-height: 1.5;">Baixando novos recursos da plataforma. Por favor, aguarde alguns segundos...</p>
            </div>
            <style>
              @keyframes spin { 100% { transform: rotate(360deg); } }
            </style>
          </div>
        `;
        document.body.appendChild(loadingDiv);
        
        // Reload the page after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason;
      
      console.log('[ChunkErrorHandler] Promise rejection:', error);
      
      // Check if it's a chunk loading error or React context error
      if (error && (
        error.message?.includes('Loading chunk') ||
        error.message?.includes('ChunkLoadError') ||
        error.message?.includes('Loading CSS chunk') ||
        error.message?.includes('Loading module') ||
        error.message?.includes('Importing a module script failed')
      )) {
        console.log('[ChunkErrorHandler] Chunk/Context loading promise rejection detected, reloading page...');
        
        // Show a brief loading message with premium design
        const loadingDiv = document.createElement('div');
        loadingDiv.innerHTML = `
          <div style="
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.95);
            backdrop-filter: blur(8px);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99999;
            font-family: 'Inter', system-ui, sans-serif;
          ">
            <div style="
              background: rgba(255, 255, 255, 0.05);
              padding: 2.5rem 3rem;
              border-radius: 1.5rem;
              border: 1px solid rgba(255, 255, 255, 0.1);
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
              text-align: center;
              max-width: 90%;
              width: 400px;
            ">
              <div style="
                width: 48px;
                height: 48px;
                border: 3px solid rgba(255, 255, 255, 0.1);
                border-top-color: #0EA5E9;
                border-radius: 50%;
                margin: 0 auto 1.5rem auto;
                animation: spin 1s linear infinite;
              "></div>
              <h2 style="font-size: 1.25rem; font-weight: 600; margin: 0 0 0.5rem 0; letter-spacing: -0.025em;">Atualizando Sistema</h2>
              <p style="font-size: 0.875rem; color: #94A3B8; margin: 0; line-height: 1.5;">Baixando novos recursos da plataforma. Por favor, aguarde alguns segundos...</p>
            </div>
            <style>
              @keyframes spin { 100% { transform: rotate(360deg); } }
            </style>
          </div>
        `;
        document.body.appendChild(loadingDiv);
        
        // Reload the page after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      
      // Check if it's a fetch error (CORS, network, etc) - but don't reload
      // Let the fetch interceptor handle it
      if (error && (
        error.message?.includes('Failed to fetch') ||
        error.message?.includes('NetworkError') ||
        error.message?.includes('CORS')
      )) {
        console.log('[ChunkErrorHandler] Fetch error detected, will be handled by fetch interceptor');
        // Prevent default to avoid showing error in console
        event.preventDefault();
      }
    };

    // Add event listeners
    window.addEventListener('error', handleChunkError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup
    return () => {
      window.removeEventListener('error', handleChunkError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
